import React from "react";
import { connect } from "react-redux";
import { RouteComponentProps, useRouteMatch } from "react-router";
import { Route, Switch } from "react-router-dom";
import { useMediaQueries } from "Shared/Responsive";
import IndexPage from "src/components/ContinueDealerOffer/Pages/IndexPage";
import ReviewPage from "src/components/ContinueDealerOffer/Pages/ReviewPage";
import Sidebar, { SidebarResponsiveContainer } from "src/components/shared/Sidebar";
import SidebarBackButton from "src/components/shared/Sidebar/SidebarButtons/SidebarBackButton";
import SidebarDetails from "src/components/shared/Sidebar/SidebarDetails";
import SidebarLogos from "src/components/shared/Sidebar/SidebarLogos";
import SidebarMSRP from "src/components/shared/Sidebar/SidebarMSRP";
import SidebarPayment from "src/components/shared/Sidebar/SidebarPayment";
import SidebarTable from "src/components/shared/Sidebar/SidebarTable";
import SidebarThumbnail from "src/components/shared/Sidebar/SidebarThumbnail";
import { ApplicationStore } from "src/store";
import "./ContinueDealerOffer.scss";

const ContinueDealerOffer = ({ vin, match: { path } }: ReturnType<typeof mapStateToProps> & RouteComponentProps) => {
    const isReviewPage = useRouteMatch("/dealer-offer/review");
    const { desktop, notDesktop } = useMediaQueries();

    return (
        <div className="ContinueDealerOffer__Container">
            <Sidebar className={"ContinueDealerOffer__Sidebar"}>
                {notDesktop && <SidebarBackButton />}
                <SidebarLogos />
                <SidebarThumbnail vin={vin} />
                {notDesktop && (
                    <SidebarResponsiveContainer>
                        <SidebarDetails vin={vin} />
                        <SidebarMSRP vin={vin} />
                        <SidebarPayment vin={vin} />
                    </SidebarResponsiveContainer>
                )}
                {desktop && (
                    <React.Fragment>
                        <SidebarDetails vin={vin} />
                        <SidebarPayment vin={vin} />
                        {!isReviewPage && <SidebarTable vin={vin} />}
                        <SidebarBackButton />
                    </React.Fragment>
                )}
            </Sidebar>

            <div className="ContinueDealerOffer__Content__Container">
                <Switch>
                    <Route exact path={path} render={() => <IndexPage />} />
                    <Route path={`${path}/review`} render={() => <ReviewPage vin={vin} />} />
                </Switch>
            </div>
        </div>
    );
};

const mapStateToProps = (state: ApplicationStore) => ({
    vin: state.currentDeal.vin as string,
});

export default connect(mapStateToProps)(ContinueDealerOffer);
